import { isDate } from "../functions/dateHelpers";
import { formatDate2, formatDateAsDate } from "../functions/formatters";

const formatTime = Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
}).format

export const protocolModelFormatField = (field, data, type, convertor) => {
    if (!data) {
        return ''
    }

    switch (type) {
        case 'text':
        case 'number':
            return protocolModelConvert(data, convertor);

        case 'employee':
            return data?.fullName ?? data;

        case 'switch':
            return data;
        case 'date':
            try {                
                const date = new Date(data);
                if (!isDate(date))
                    return data;
                return formatDateAsDate(date);                
            } catch (e) {
                return data;
            }

        case 'datetime':
            try {
                return formatTime(new Date(data));
            } catch (e) {
                return data;
            }
        default:
            return data;
    }
}

export const protocolModelConvert = (value, convertor) => {
    if (!value)
        return value;

    if (!convertor)
        return value;

    try {
        switch (convertor) {
            case 'date':
                if (!value.endsWith('Z'))
                    return value;                
        }

        return protocolModelFormatField(null, value, convertor, null);
    } catch {
        return value;
    }
}